import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Comments, CommentsV1 } from '../../components/widgets';
import { getCommentsData, addComments } from '../../store/comments/actions';

const CommentBox = (props) => {
  const { isNewUI } = props;
  if (isNewUI) return <CommentsV1 {...props} />;
  else return <Comments {...props} />;
};

export default withRouter(
  connect(
    (state, ownProps) => {
      const { commentsState, ordersState } = state;
      const { isShowShimmer, isNewUI } = ordersState;
      const { commentsList } = commentsState;
      const { cartId } = ownProps;
      const comments =
        cartId &&
        commentsList &&
        commentsList[cartId] &&
        commentsList[cartId].length
          ? commentsList[cartId]
          : null;
      return {
        isShowShimmer,
        comments,
        cartId,
        isNewUI,
      };
    },
    (dispatch) => {
      return {
        getCommentsData: (data) => dispatch(getCommentsData(data)),
        addComments: (data) => dispatch(addComments(data)),
      };
    },
  )(CommentBox),
);
